import React from 'react';

export function OfflineMapSettings() {
    return ( <p>Offline Settings</p>);
}